import { ChakraProvider } from '@chakra-ui/react';
import ReactDOM from 'react-dom';
import { HashRouter, Redirect, Route, Switch } from 'react-router-dom';
import './assets/css/App.css';
import AdminLayout from './layouts/admin';
import AuthLayout from './layouts/auth';
import theme from './theme/theme';
import { GoogleOAuthProvider } from '@react-oauth/google';

const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

ReactDOM.render(
	<GoogleOAuthProvider clientId={clientId}>
		<ChakraProvider theme={theme}>

			<HashRouter>
				<Switch>
					<Route path={`/auth`} component={AuthLayout} />
					<Route path={`/admin`} component={AdminLayout} />
					<Redirect from='/' to='/auth' />
				</Switch>
			</HashRouter>

		</ChakraProvider>
	</GoogleOAuthProvider>,
	document.getElementById('root')
);
